import React, {Component} from "react";
import {connect} from "react-redux";
import * as actions from "Actions";
import {Close} from "../../../components/utils/SvgIcons";
import Checkbox from "Utils/Checkbox";
import {getRememberDeviceStamp} from "../../../api";
import moment from "moment";
import {
  TWO_FACTOR_AUTH_STATE_ENTER_CODE,
} from "Constants/redux";

class PhoneCodeForm extends Component {

  constructor() {
    super();
    this.state = {
      codeDigit1: '',
      codeDigit2: '',
      codeDigit3: '',
      codeDigit4: '',
      codeDigit5: '',
      codeDigit6: '',
      shouldRememberDevice: false
    }
  }

  handleCodeChange = index => e => {
    switch (index) {
      case 1:
        this.setState({codeDigit1: e.target.value})
        break;
      case 2:
        this.setState({codeDigit2: e.target.value})
        break;
      case 3:
        this.setState({codeDigit3: e.target.value})
        break;
      case 4:
        this.setState({codeDigit4: e.target.value})
        break;
      case 5:
        this.setState({codeDigit5: e.target.value})
        break;
      case 6:
        this.setState({codeDigit6: e.target.value})
        break;
    }
    const {maxLength, value, name} = e.target;
    const [fieldName, fieldIndex] = name.split("-");

    let fieldIntIndex = parseInt(fieldIndex, 10);

    // Check if no of char in field == maxlength
    if (value.length >= maxLength) {

      // It should not be last input field
      if (fieldIntIndex < 6) {

        // Get the next input field using it's name
        const nextfield = document.querySelector(
          `input[name=codeDigit-${fieldIntIndex + 1}]`
        );

        // If found, focus the next field
        if (nextfield !== null) {
          nextfield.focus();
        }
      }
    }
  }

  handleDevice14DaysCheck = (isChecked) => {
    this.setState({shouldRememberDevice: isChecked})
  }

  formValidation = () => {
    const {email, password} = this.props;
    let isValid = true;
    let validationErrors = [];

    if (email.trim().length === 0 || !email.includes('@')) {
      validationErrors = ["Please enter a valid email"];
      isValid = false;
    }

    if (password.trim().length === 0) {
      validationErrors = [...validationErrors, "Password is required"];
      isValid = false;
    }

    return {isValid, validationErrors};
  }

  onSubmit(e) {
    e.preventDefault();

    const {
      email,
      password,
      dispatchSetErrors,
      loginUserWithATwoFactor
    } = this.props;

    const {
      shouldRememberDevice,
      codeDigit1,
      codeDigit2,
      codeDigit3,
      codeDigit4,
      codeDigit5,
      codeDigit6
    } = this.state;

    let phoneCode = `${codeDigit1}${codeDigit2}${codeDigit3}${codeDigit4}${codeDigit5}${codeDigit6}`;
    const {isValid, validationErrors} = this.formValidation();

    if (!isValid) {
      dispatchSetErrors(validationErrors)
      return;
    }

    if (!phoneCode) {
      phoneCode = '-';
    }

    loginUserWithATwoFactor({email, password, shouldRememberDevice, phoneCode});
  }

  render() {

    const {
      codeDigit1,
      codeDigit2,
      codeDigit3,
      codeDigit4,
      codeDigit5,
      codeDigit6
    } = this.state;
    const {resetTwoFactor, loading, handleHitSmsApi} = this.props;

    return (
      <div className="contentWrapperTwoFactor">
        <div className="content ">
          <div className="container-header">
            <h4>Two-Factor Authentication</h4>
            <a onClick={resetTwoFactor}><Close/></a>
          </div>
          <p>A message with verification code has been sent to your mobile
            phone.</p>
          <p>Enter the code to continue:</p>
          <div className="container-two-factor-content">
            <input
              name="codeDigit-1"
              type="text"
              maxLength={1}
              value={codeDigit1}
              onChange={this.handleCodeChange(1)}
              autoFocus
            />
            <input
              name="codeDigit-2"
              type="text"
              maxLength={1}
              value={codeDigit2}
              onChange={this.handleCodeChange(2)}
            />
            <input
              name="codeDigit-3"
              type="text"
              maxLength={1}
              value={codeDigit3}
              onChange={this.handleCodeChange(3)}
            />
            <input
              name="codeDigit-4"
              type="text"
              maxLength={1}
              value={codeDigit4}
              onChange={this.handleCodeChange(4)}
            />
            <input
              name="codeDigit-5"
              type="text"
              maxLength={1}
              value={codeDigit5}
              onChange={this.handleCodeChange(5)}
            />
            <input
              name="codeDigit-6"
              type="text"
              maxLength={1}
              value={codeDigit6}
              onChange={this.handleCodeChange(6)}
            />
          </div>
          <p>
            <Checkbox
              onCheck={(event, isChecked) => this.handleDevice14DaysCheck(isChecked)}
            /> &nbsp;
            Remember this device for 14 days?
          </p>
          <div className="container-buttons">
            <button
              className={loading ? "btn fullWidth disabled" : "btn fullWidth"}
              onClick={this.onSubmit.bind(this)}>
              {loading ? 'Please wait...' : 'Verify'}
            </button>
            <button className="btn cancel" onClick={handleHitSmsApi}>
              Re-Send Text Message
            </button>
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => {
  const {errors, loading} = state.auth;
  return {errors, loading};
};

export default connect(mapStateToProps, actions)(PhoneCodeForm);
